import { message, Radio, Space } from "antd";
import Modal from "antd/lib/modal/Modal";
import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchPaymentList, SelectPayment } from "../../network/cart.network";
import { setPaymentUser } from "../../redux/user/user.action";

class SelectPayMethod extends Component {
  state = {
    showModal: false,
    confirmLoading: false,
    value: 2,
    PaymentList : []
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  componentDidMount() {
    fetchPaymentList((res) => {
      console.log(res.data.data.types);
      this.setState({PaymentList : res.data.data.types})
    }, (error) => {
      console.log(error); 
    })
  }
  

  componentDidUpdate(prevProps) {
    if (this.props.showModalVisible !== this.state.showModal) {
      this.setState({ showModal: this.props.showModalVisible });
    }
  }

  onChange = (e) => {
    this.setState({
      value: e.target.value,
    });
  };

  handelSelectPayment = () => {
    const { value } = this.state;
    this.setState({ confirmLoading: true });
    let body = new FormData();
    body.append("paymentTypeId", +value); 
    SelectPayment( 
      body,
      (res) => {
        this.setState({ confirmLoading: false});
        this.props.closeModal(); 
        if (res.data.code === 200) {
          message.success(res.data.message);
          this.props.dispatch(setPaymentUser(res.data.data.paymentType)) 
          this.props.setPaymentCallBack(res.data.data.paymentType);  
        }
      },
      (error) => {
        this.setState({ confirmLoading: false });
        console.log(error); 
      }
    );
  };

  render() {
    const { showModal, value, confirmLoading, PaymentList } = this.state;
    const { currentLang, localization } = this.props;
    return (
      <div className="pay-modal-wrapper">
        <Modal
          wrapClassName="pay-modal"
          onCancel={this.props.closeModal}
          title="" 
          okText={localization.Save[currentLang]} 
          // cancelText={localization.Addnewone[currentLang]}  
          cancelText={null}
          onOk={this.handelSelectPayment}
        //   onCancel={() => console.log('object') }
          confirmLoading={confirmLoading}
          visible={showModal}
        >
          <Radio.Group onChange={this.onChange} value={value}>
            <Space direction="vertical"> 
              {PaymentList.map(type => 
                  <Radio value={type.id} key={type.id}>{type.name}   
                  {/* <span className="cost-info">({localization.itcosts[currentLang]}  20 {localization.AED[currentLang]}  )</span> */}
                  </Radio>
              )}
            </Space>
          </Radio.Group>
        </Modal>
      </div>
    );
  }
}

export default connect()(SelectPayMethod); 
